import ArrowButton from "@/components/Buttons/ArrowButton/ArrowButton";
import ArrowFile from "@/components/Buttons/ArrowButton/ArrowFile";
import Title from "@/components/Title/Title";
import { IImage, ILink } from "@/src/types";
import { Wysiwyg } from "@/styles/typography";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React, { useState, useEffect } from "react";
import S from "./ImageTextColor.style";
import { getCopy } from '@/src/helpers';

export interface Props {
  title: string;
  backgroundColor: string;
  buttonType: {
    link: ILink;
    file: {
      mediaItemUrl: string;
    };
    fileTitle: string;
  };
  image: IImage;
  layout: string;
  backgroundLayout: string;
  text: string;
  video: {
    localFile: {
      publicURL: string;
    };
    mimeType: string;
  };
  mediaType: string;
}

const ImageTextColor: React.FC<Props> = (data) => {
  const {
    backgroundColor,
    title,
    image,
    text,
    buttonType,
    layout,
    backgroundLayout,
    mediaType,
    video,
  } = data;

  const [selectedBackgroundColor, setSelectedBackgroundColor] =
    useState("white");

  useEffect(() => {
    if (backgroundColor === "white") {
      setSelectedBackgroundColor("white");
    } else if (backgroundColor === "blue") {
      setSelectedBackgroundColor("#224C5D");
    } else if (backgroundColor === "black") {
      setSelectedBackgroundColor("#000000");
    } else if (backgroundColor === "green") {
      setSelectedBackgroundColor("#2F5A50");
    }
  }, [backgroundColor]);

  // Gatsby Image
  const imageData = image?.gatsbyImage ? getImage(image.gatsbyImage) : null;

  return (
    <div className="main-inner">
      <S.Container>
        {layout === "left" && (
          <>
            <S.BackgroundLeft
              layout={backgroundLayout}
              backgroundColor={selectedBackgroundColor}
            />
            {mediaType === "image" && imageData && (
              <>
                <GatsbyImage
                  className="gatsby-image"
                  image={imageData}
                  alt={image.altText}
                />
                <S.P layout={layout} className="">&copy; {image?.caption ? image?.caption.replace(/[<p>|</p>]/g, '') : getCopy(image.altText, image.sourceUrl)}{' '}</S.P>
              </>
            )}
            {mediaType === "video" && video && (
              <>
                <S.Video
                  className="video-with-title-video"
                  loop
                  autoPlay
                  muted
                  playsInline
                >
                  <source
                    src={video.localFile.publicURL}
                    type={video.mimeType}
                  />
                </S.Video>
              </>
            )}
          </>
        )}

        {mediaType === "image" && imageData && (
          <GatsbyImage
            className="gatsby-image-mobile"
            image={imageData}
            alt={image.altText}
          />
          )}
        {mediaType === "video" && video && (
          <S.MobileVideo
            className="video-with-title-video"
            loop
            autoPlay
            muted
            playsInline
          >
            <source src={video.localFile.publicURL} type={video.mimeType} />
          </S.MobileVideo>
        )}

        <S.TextWrapper backgroundColor={selectedBackgroundColor}>
          <Title title={title} backgroundColor={backgroundColor} />
          {text && (
            <Wysiwyg
              color={backgroundColor === "white" ? "#224C5D" : "#f9f9f9"}
              dangerouslySetInnerHTML={{ __html: text }}
            />
          )}
          {buttonType &&
            (buttonType.file ? (
              <ArrowFile
                button={buttonType.file}
                title={buttonType.fileTitle}
                backgroundColor={backgroundColor}
              />
            ) : (
              buttonType.link && (
                <ArrowButton
                  button={buttonType.link}
                  backgroundColor={backgroundColor}
                />
              )
            ))}
        </S.TextWrapper>
        {layout === "right" && (
          <>
            <S.BackgroundRight
              backgroundLayout={backgroundLayout}
              backgroundColor={selectedBackgroundColor}
            />
            {mediaType === "image" && imageData && (
              <>
                <GatsbyImage
                  className="gatsby-image"
                  image={imageData}
                  alt={image.altText}
                />
                <S.P layout={layout} className="">&copy; {image?.caption ? image?.caption.replace(/[<p>|</p>]/g, '') : getCopy(image.altText, image.sourceUrl)}{' '}</S.P>
              </>
            )}
            {mediaType === "video" && video && (
              <S.Video
                className="video-with-title-video"
                loop
                autoPlay
                muted
                playsInline
              >
                <source src={video.localFile.publicURL} type={video.mimeType} />
              </S.Video>
            )}
          </>
        )}
      </S.Container>
    </div>
  );
};

export default ImageTextColor;
